import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReportsAPI from '../services/reportsAPI';
import ModernTable from '../components/common/ModernTable';
import styles from './CompletedVoyageReport.module.css';
// ...existing code...
const XLSX = require('xlsx');

function formatLocalDate(dateStr) {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    if (isNaN(d)) return '-';
    return d.toLocaleDateString();
}

const DetentionReport = () => {

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [bookingNumber, setBookingNumber] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchReport = () => {
        if ((!startDate || !endDate) && !bookingNumber) {
            setError('Please select both start and end dates or enter a booking number');
            return;
        }
        setLoading(true);
        setError(null);
        ReportsAPI.getDetentionReport(startDate, endDate, bookingNumber)
            .then((res) => {
                setData(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setError('Failed to fetch detention report');
                setLoading(false);
            });
    };

    // Filter logic similar to ContainerDwellTimeReport
    const filteredData = React.useMemo(() => {
        if (!searchTerm.trim()) return data;
        const lowerSearch = searchTerm.toLowerCase();
        return data.filter(row =>
            (row.container_number && row.container_number.toLowerCase().includes(lowerSearch)) ||
            (row.location && row.location.toLowerCase().includes(lowerSearch)) ||
            (row.discharged_date && formatLocalDate(row.discharged_date).toLowerCase().includes(lowerSearch)) ||
            (row.next_milestone_date && formatLocalDate(row.next_milestone_date).toLowerCase().includes(lowerSearch))
        );
    }, [data, searchTerm]);

    // Excel download handler
    const handleDownloadExcel = () => {
        const dataToExport = filteredData.map(row => ({
            'Container Number': row.container_number,
            'Location': row.location,
            'Discharged Date': formatLocalDate(row.discharged_date),
            'Free Days': row.free_days,
            'Free Days End Date': formatLocalDate(row.free_days_end_date),
            'Container (Empty) Return Date': formatLocalDate(row.next_milestone_date),
            'Falls In Range': row.falls_in_range,
            'Detention Days': row.days_remaining_before_next_milestone
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Detention Report');
        XLSX.writeFile(workbook, 'DetentionReport.xlsx');
    };

    const navigate = useNavigate();
    const columns = [
        { key: 'booking_number', label: 'Booking Number' },
        { key: 'container_number', label: 'Container Number' },
        { key: 'location', label: 'Location' },
        {
            key: 'discharged_date',
            label: 'Discharged Date',
            render: (val) => formatLocalDate(val)
        },
        { key: 'free_days', label: 'Free Days' },
        {
            key: 'free_days_end_date',
            label: 'Free Days End Date',
            render: (val) => formatLocalDate(val)
        },
        {
            key: 'next_milestone_date',
            label: 'Container (Empty) Return Date',
            render: (val) => formatLocalDate(val)
        },
        { key: 'falls_in_range', label: 'Falls In Range' },
        { key: 'days_remaining_before_next_milestone', label: 'Detention Days' },
    ];

    return (
        <div className={styles.completedVoyageReport}>
            <button onClick={() => navigate('/agent/dashboard')} className={styles.backButton}>
                &larr; Back to Dashboard
            </button>
            <h2 className={styles.heading}>Detention Report</h2>
            <div className={styles.dateRow}>
                <label className={styles.dateLabel}>
                    Start Date:
                    <input
                        type="date"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        className={styles.dateInput}
                    />
                </label>
                <label className={styles.dateLabel}>
                    End Date:
                    <input
                        type="date"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        className={styles.dateInput}
                    />
                </label>
                <br />
                (OR)
                <br />
                <label className={styles.dateLabel}>
                    Booking Number:
                    <input
                        type="text"
                        value={bookingNumber}
                        onChange={e => setBookingNumber(e.target.value)}
                        className={styles.dateInput}
                        placeholder="Enter booking number"
                    />
                </label>
            </div>
            <div className={styles.actionRow}>
                <button onClick={fetchReport} className={"btn btn-sm btn-primary " + styles.fetchButton} disabled={loading}>
                    {loading ? "Loading..." : "Fetch Report"}
                </button>
            </div>
            <div className={styles.searchRow}>
                <input
                    type="text"
                    placeholder="Search by container number, location, date..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    className={styles.searchInput}
                />
                <button onClick={handleDownloadExcel} className={"btn btn-sm btn-success " + styles.downloadButton}>
                    Download this report
                </button>
            </div>
            {error && <div style={{ color: "red" }}>{error}</div>}
            <ModernTable columns={columns} data={filteredData} />
        </div>
    );
};

export default DetentionReport;
